import React from "react";

import styles from "./Icon.module.scss";

type Props = {
  isCenter?: boolean;
  type: "loading" | "success" | "error";
};

export const Icon: React.FC<Props> = ({ isCenter, type }) => {
  return (
    <div
      role="presentation"
      style={{
        textAlign: isCenter ? "center" : "left",
      }}
    >
      <div className={styles.icon} data-type={type} />
    </div>
  );
};
